import m from "../../geodata/es2015/kazakhstanLow";
window.am4geodata_kazakhstanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/kazakhstanLow.js
// module id = null
// module chunks = 